/**
 * RBAC do manager: permissões vêm de GET /manager/me como "resource:action".
 * Super admin: lista contém "*" (bypass no front; o backend valida sempre).
 */
export function can(
  permissions: string[] | undefined,
  resource: string,
  action: string,
): boolean {
  if (!permissions?.length) {
    return false;
  }
  if (permissions.includes('*')) {
    return true;
  }
  return permissions.includes(`${resource}:${action}`);
}
